import { useMemo, useRef } from 'react';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LearningContentCardsSkeleton } from 'academy-common-lib/components/Skeletons/LearningContentCardsSkeleton';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ITEM_TYPE_TO_LEARNING_CONTENT_TYPE = {
  COURSE: 'TRACK',
  LESSON: 'LESSON',
  SHORT_VIDEO: 'SHORT_FORM_CONTENT',
  // @ts-expect-error LEARNING_PATH not yet added to CatalogItemType in CopilotMessageService
  LEARNING_PATH: 'LEARNING_PATH'
};
export const RecommendationCard = ({
  section: {
    itemId,
    itemType,
    language
  }
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    onContentCardClick,
    onContentCardImpression
  } = useAcademyChatActions();
  const items = useMemo(() => {
    const type = ITEM_TYPE_TO_LEARNING_CONTENT_TYPE[itemType];
    if (!type) return [];
    return [{
      id: itemId,
      type,
      language: itemType === 'COURSE' || itemType === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toLowerCase() : undefined
    }];
  }, [itemId, itemType, language]);
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items,
    skip: !items.length
  });
  const contentType = ITEM_TYPE_TO_LEARNING_CONTENT_TYPE[itemType];
  const hasTrackedImpressionRef = useRef(false);
  if (cardModelsLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginBlockEnd: isMobile ? '400' : undefined,
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(LearningContentCardsSkeleton, {
          skeletonCardSize: "small",
          use: "on-light",
          maxSkeletonListLength: 1
        })
      })
    });
  }
  if (cardModelsError || !(cardModels !== null && cardModels !== void 0 && cardModels.length)) {
    return null;
  }
  if (!hasTrackedImpressionRef.current && contentType) {
    hasTrackedImpressionRef.current = true;
    onContentCardImpression(itemId, contentType);
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginBlockStart: "400",
    marginBlockEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(LearningContentCard, {
        item: cardModels[0],
        size: "small",
        overviewType: "academy-assistant",
        onItemClick: () => {
          if (contentType) {
            onContentCardClick(itemId, contentType);
          }
        }
      })
    })
  });
};
export const AcademyRecommendations = ({
  pair
}) => {
  var _parsed$modelResult$d, _parsed;
  const output = pair.output;
  if (!output || output.type !== 'TEXT' || output.isError) return null;
  let parsed = null;
  try {
    parsed = JSON.parse(output.content);
  } catch (_unused) {
    return null;
  }
  const sections = (_parsed$modelResult$d = (_parsed = parsed) === null || _parsed === void 0 || (_parsed = _parsed.modelResult) === null || _parsed === void 0 ? void 0 : _parsed.dynamicResponseSections) !== null && _parsed$modelResult$d !== void 0 ? _parsed$modelResult$d : [];
  if (!sections.length) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sections.map(({
      id,
      responseSection
    }) => /*#__PURE__*/_jsx(RecommendationCard, {
      section: responseSection
    }, id))
  });
};